/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDeviceItemModel } from '../../models/dashboard-device-item-model';
import { DashboardRequestModel } from '../../models/dashboard-request-model';

export interface DashboardDeviceSummaryOrganizationIdPost$Params {

/**
 * Organization identifier.
 */
  organizationId: string;
  
    /**
     * Request model containing date range and summary type.
     */
    body?: DashboardRequestModel
}

export function dashboardDeviceSummaryOrganizationIdPost(http: HttpClient, rootUrl: string, params: DashboardDeviceSummaryOrganizationIdPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<Array<DashboardDeviceItemModel>>> {
  const rb = new RequestBuilder(rootUrl, dashboardDeviceSummaryOrganizationIdPost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<Array<DashboardDeviceItemModel>>;
    })
  );
}

dashboardDeviceSummaryOrganizationIdPost.PATH = '/Dashboard/DeviceSummary/{organizationId}';
